import styled from 'styled-components';
import { PriceVatExcludedStyled } from '../PriceVatExcludedStyled';
export const PriceVatExcludedStyledAP = styled(PriceVatExcludedStyled)`
    color: #63666a;
    font-size: inherit;
    font-weight: bold;
`;
